import { NavLink } from "react-router-dom";

export function SectionPricing1Inner() {
    return (
        <>
           
        </>
    )
}

function SectionPricing1() {
    return (
        <>
            {/* <div className="section-full p-t110 p-b110 sx-p-table-outer sx-bg-white wow fadeInDown" data-wow-duration="1000ms">
                <SectionPricing1Inner />
            </div> */}
        </>
    )
}

export default SectionPricing1;